module.exports = __webpack_public_path__ + "img/smallcompanies-video-thumb.f104079e.png";